module.exports = "/call-frontend/img/icon_edit_outline.aa038bdb.svg";